"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="mx-auto max-w-[1200px] px-4 py-24 text-center sm:px-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted">
        Something broke
      </p>
      <h1 className="mt-3 font-serif text-[28px] text-heading">
        Couldn&apos;t load this page
      </h1>
      <p className="mx-auto mt-3 max-w-[44ch] text-[13px] leading-relaxed text-muted">
        Prices are safe; this is on us, not your connection. Try again, and if
        it keeps happening, come back in a few minutes.
      </p>
      <button
        type="button"
        onClick={reset}
        className="mt-6 h-9 rounded-md bg-primary-500 px-4 text-[13px] font-medium text-background-950 transition-colors duration-150 hover:bg-primary-400"
      >
        Retry
      </button>
    </div>
  );
}
